var imageIdManger = {
  id: 0,
  name: 'QUILL_IMAGE_PLUS',
  generate: function generate() {
    var id = this.id;
    this.id = id + 1;
    return "".concat(this.name, "_").concat(id);
  }
};
module.exports = imageIdManger;